export interface TimeRemaining {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
}

export const calculateTimeRemaining = (endDate: string | null | undefined): TimeRemaining => {
  if (!endDate) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
  }

  try {
    const now = new Date().getTime();
    const end = new Date(endDate).getTime();
    
    // Check if the date is invalid
    if (isNaN(end)) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
    }
    
    const difference = end - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds, isExpired: false };
  } catch (error) {
    // Handle any parsing errors gracefully
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
  }
};

export const formatTimeRemaining = (timeRemaining: TimeRemaining): string => {
  if (timeRemaining.isExpired) {
    return 'Expired';
  }

  const { days, hours, minutes, seconds } = timeRemaining;
  
  // Dynamic formatting based on time remaining (always include seconds):
  // If >= 1 day: "3d 17h 50m 25s"
  // If >= 1 hour: "17h 50m 25s"  
  // If < 1 hour: "50m 25s"
  
  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  } else if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  } else {
    return `${minutes}m ${seconds}s`;
  }
};